// extracted by mini-css-extract-plugin
export default {"br":"Xj","w80":"Yj","card":"Zj","wrapper":"ak","fullView":"bk","profilePic":"ck","comment":"ek","animate":"fk","shimmer":"gk","square":"hk"};
    if(module.hot) {
      // 1713809675125
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  